var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-img',{staticClass:"static-image",attrs:{"id":"static - image","src":_vm.$ebsn.meta(_vm.config, 'categoryblocktype_StaticImage.IMAGE.location')}})
}
var staticRenderFns = []

export { render, staticRenderFns }